import React, { useEffect, useState, useContext } from "react";
import styled from "styled-components";
import { Button } from "@mui/material";
import { styled as style } from "@mui/material/styles";
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import { Modal, Button as RsuiteBtn } from "rsuite";
import Logger from "../../libraries/Logger";
import apiClient from "../../libraries/ApiClient";
import { AuthContext } from "../../contexts/AuthContext";

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 10px;
  position: sticky;
  top: 0px;
  .title {
    font-size: 20px;
    color: #252525;
    margin-bottom: 0.5rem;
  }
  .btn {
    display: flex;
    justify-content: space-between;
    width: 110px;
  }
  @media (max-width: 1200px) {
    top: 50px;
    background-color: #fff;
    z-index: 8;
  }
`;

const CssCancelButton = style(Button)({
  fontSize: 12,
  borderColor: "#057AFF",
  backgroundColor: "#fff",
  padding: "3px 0px",
  "&:hover": {
    borderColor: "#1570EF",
    backgroundColor: "#fff",
    cursor: "pointer",
  },
});

const CssSaveButton = style(Button)({
  fontSize: 12,
  backgroundColor: "#057AFF",
  padding: "4px 0px",
  boxShadow: "none",
  borderColor: "#057AFF",

  "&:hover": {
    backgroundColor: "#1570EF",
    cursor: "pointer",
    boxShadow: "none",
    borderColor: "#057AFF",
  },
});

function HospitalEditTitle({ Mode, rowId, sendHospitalData }) {
  const navigate = useNavigate();
  const { myAuth } = useContext(AuthContext);
  const [token, setToken] = useState("");
  const [AccountId, setAccountId] = useState("");
  const [saveOpen, setSaveOpen] = useState(false);
  const [cancelOpen, setCancelOpen] = useState(false);
  const [myself, setMySelf] = useState(false);
  const [isAdmin, setIsAdmin] = useState(null);
  const [AccountPermission, setAccountPermission] = useState(null);

  const handleCancelOpen = () => setCancelOpen(true);
  const handleCancelClose = () => setCancelOpen(false);

  useEffect(() => {
    setToken(JSON.parse(localStorage.getItem("auth"))?.Token);

    setAccountId(JSON.parse(localStorage.getItem("auth"))?.AccountRowId);

    setIsAdmin(myAuth.IsAdmin);
    setAccountPermission(myAuth.AccountPermission);
  }, []);

  const sendFormData = async ({ sendHospitalData }) => {
    const data = {
      Data: sendHospitalData,
    };
    console.log(data);

    const result = await apiClient.postAes(
      "api/Organization/Update/Security",
      data
    );
    if (result?.status === 401) {
      alert("您的授權已失效，請重新登入");
      navigate("/Login");
    }

    if (+result?.data?.Code !== 0 || result?.status !== 200) {
      alert("機構存檔失敗");
    }

    return result;
  };

  const { data, mutate, isSuccess, isLoading } = useMutation(sendFormData, {
    onSuccess: (data) => {
      const { Code, Message } = data?.data;
      console.log(data?.data);
      if (+Code === 1) {
        alert(Message);
      }
      if (+Code === 0) {
        alert("修改成功");
        navigate("/HospitalManageList");
      }
    },
  });

  const { data: FormResData } = data || {};
 
  const NoAdminHandler = () => {
    navigate("/ReferralDataList");
  };

  return (
    <Container>
      <ul>
        <li>
          <div className="title">編輯合作機構</div>
        </li>
      </ul>
      <div className="btn">
        <div>
          <CssCancelButton
            size="small"
            variant="outlined"
            style={{ minWidth: "50px" }}
            onClick={
              AccountPermission == 1 || AccountPermission == 2
                ? handleCancelOpen
                : NoAdminHandler
            }
          >
            取消
          </CssCancelButton>
        </div>
        <div>
          <CssSaveButton
            size="small"
            variant="contained"
            style={{ minWidth: "50px" }}
            onClick={() => {
              mutate({ sendHospitalData });
            }}
          >
            存檔
          </CssSaveButton>
        </div>
      </div>
   
      <Modal open={cancelOpen} onClose={handleCancelClose} backdrop="static">
        <Modal.Header>
          <Modal.Title>提示資訊</Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            height: "100px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-around",
          }}
        >
          <div style={{ fontSize: "18px" }}>若有資料未儲存</div>
          <div style={{ fontSize: "14px" }}>「確認」取消將不保留您的資料</div>
        </Modal.Body>
        <Modal.Footer>
          <RsuiteBtn
            style={{
              backgroundColor: "#3498ff",
              color: "#ffffff",
            }}
            onClick={() => {
              isAdmin == true
                ? navigate("/HospitalManageList")
                : navigate("/ReferralDataList");
            }}
          >
            確認
          </RsuiteBtn>
          <RsuiteBtn onClick={handleCancelClose}>取消返回</RsuiteBtn>
        </Modal.Footer>
      </Modal>
    </Container>
  );
}

export default HospitalEditTitle;
